export const ROUTE_PATHS = {
  login: '/giris',
  dashboard: '/anasayfa',
  announcements: '/duyurular',
  directory: '/personel-rehberi',
  documents: '/dokuman-merkezi',
  hr: '/insan-kaynaklari',
  applications: '/basvurular',
  newEmployee: '/yeni-calisan',
  allEmployees: '/tum-calisanlar',
  profile: '/profil',
  events: '/etkinlik-takvimi',
  surveys: '/anketler',
  innovation: '/inovasyon-oneri',
  administrative: '/idari-isler',
  selfService: '/operasyonel-servisler',
  administrativeRequests: '/idari-isler-talepler',
  administrativeStats: '/idari-isler-istatistikler',
  inventory: '/zimmet-yonetimi',
  inventoryList: '/zimmet-listesi',
  newInventory: '/yeni-zimmet',
  inventoryReports: '/zimmet-raporlari'
};

export const LEGACY_ROUTE_REDIRECTS = [
  { from: '/dokumanlar', to: ROUTE_PATHS.documents },
  { from: '/personel', to: ROUTE_PATHS.directory }
];

export const PAGE_TITLES = {
  [ROUTE_PATHS.dashboard]: 'Anasayfa',
  [ROUTE_PATHS.announcements]: 'Duyurular',
  [ROUTE_PATHS.directory]: 'Personel Rehberi',
  [ROUTE_PATHS.documents]: 'Doküman Merkezi',
  [ROUTE_PATHS.hr]: 'İnsan Kaynakları',
  [ROUTE_PATHS.applications]: 'Başvurular',
  [ROUTE_PATHS.newEmployee]: 'Yeni Çalışan Kaydı',
  [ROUTE_PATHS.allEmployees]: 'Tüm Çalışanlar',
  [ROUTE_PATHS.profile]: 'Profil',
  [ROUTE_PATHS.events]: 'Etkinlik Takvimi',
  [ROUTE_PATHS.surveys]: 'Anketler',
  [ROUTE_PATHS.innovation]: 'Öneri ve Talep Kutusu',
  [ROUTE_PATHS.administrative]: 'İdari İşler',
  [ROUTE_PATHS.selfService]: 'Operasyonel Servisler',
  [ROUTE_PATHS.administrativeRequests]: 'İdari İşler Talepleri',
  [ROUTE_PATHS.administrativeStats]: 'İdari İşler İstatistikleri',
  [ROUTE_PATHS.inventory]: 'Zimmet Yönetimi',
  [ROUTE_PATHS.inventoryList]: 'Zimmet Listesi',
  [ROUTE_PATHS.newInventory]: 'Yeni Zimmet',
  [ROUTE_PATHS.inventoryReports]: 'Zimmet Raporları'
};

export const NAVIGATION_GROUPS = [
  {
    key: 'kurumsal',
    label: 'Kurumsal',
    icon: 'bx bxs-buildings',
    description: 'Şirket içi iletişim ve temel bilgi alanları',
    items: [
      { key: 'announcements', label: 'Duyurular', path: ROUTE_PATHS.announcements },
      { key: 'documents', label: 'Doküman Merkezi', path: ROUTE_PATHS.documents },
      {
        key: 'policies',
        label: 'Politika ve Prosedürler',
        path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`
      },
      {
        key: 'forms',
        label: 'Formlar ve Şablonlar',
        path: `${ROUTE_PATHS.documents}?kategori=form-sablon`
      },
      { key: 'directory', label: 'Personel Rehberi', path: ROUTE_PATHS.directory },
      { key: 'events', label: 'Etkinlik Takvimi', path: ROUTE_PATHS.events },
      { key: 'surveys', label: 'Anketler', path: ROUTE_PATHS.surveys }
    ]
  },
  {
    key: 'insan-kariyer',
    label: 'İnsan ve Kariyer',
    icon: 'bx bxs-user',
    description: 'İK süreçleri ve çalışan yaşam döngüsü',
    items: [
      { key: 'hr', label: 'İK Merkezi', path: ROUTE_PATHS.hr },
      { key: 'applications', label: 'Başvurular', path: ROUTE_PATHS.applications, roles: ['admin', 'manager'] },
      { key: 'newEmployee', label: 'Yeni Çalışan Kaydı', path: ROUTE_PATHS.newEmployee, roles: ['admin', 'manager'] },
      { key: 'allEmployees', label: 'Tüm Çalışanlar', path: ROUTE_PATHS.allEmployees, roles: ['admin', 'manager'] }
    ]
  },
  {
    key: 'operasyonlar',
    label: 'Operasyonlar',
    icon: 'bx bxs-briefcase',
    description: 'Günlük talepler ve operasyonel yönetim',
    items: [
      { key: 'administrative', label: 'İdari İşler', path: ROUTE_PATHS.administrative },
      { key: 'selfService', label: 'Operasyonel Servisler', path: ROUTE_PATHS.selfService },
      { key: 'administrativeRequests', label: 'Taleplerim', path: ROUTE_PATHS.administrativeRequests },
      { key: 'administrativeStats', label: 'İstatistikler', path: ROUTE_PATHS.administrativeStats },
      { key: 'inventory', label: 'Zimmet Yönetimi', path: ROUTE_PATHS.inventory },
      { key: 'inventoryList', label: 'Zimmet Listesi', path: ROUTE_PATHS.inventoryList },
      { key: 'inventoryReports', label: 'Raporlar', path: ROUTE_PATHS.inventoryReports }
    ]
  },
  {
    key: 'katilim-gelisim',
    label: 'Katılım ve Gelişim',
    icon: 'bx bxs-bulb',
    description: 'Katılım, öneri ve gelişim alanları',
    items: [
      { key: 'innovation', label: 'Öneri ve Talep Kutusu', path: ROUTE_PATHS.innovation },
      {
        key: 'academy',
        label: 'Koloğlu Akademi',
        path: 'https://akademi.kologlu.com.tr',
        external: true
      }
    ]
  }
];

export const SEARCH_ITEMS = [
  {
    title: 'Anasayfa',
    url: ROUTE_PATHS.dashboard,
    type: 'Sayfa',
    keywords: ['anasayfa', 'dashboard', 'hızlı erişim']
  },
  {
    title: 'Duyurular',
    url: ROUTE_PATHS.announcements,
    type: 'Sayfa',
    keywords: ['duyuru', 'haber', 'bildirim']
  },
  {
    title: 'Doküman Merkezi',
    url: ROUTE_PATHS.documents,
    type: 'Sayfa',
    keywords: ['doküman', 'belge', 'dosya', 'form', 'prosedür', 'politika', 'şablon']
  },
  {
    title: 'Personel Rehberi',
    url: ROUTE_PATHS.directory,
    type: 'Sayfa',
    keywords: ['personel', 'çalışan', 'rehber', 'ekip']
  },
  {
    title: 'İnsan Kaynakları',
    url: ROUTE_PATHS.hr,
    type: 'Sayfa',
    keywords: ['ik', 'izin', 'masraf', 'başvuru']
  },
  {
    title: 'İdari İşler',
    url: ROUTE_PATHS.administrative,
    type: 'Sayfa',
    keywords: ['talep', 'kırtasiye', 'telefon', 'aksesuar']
  },
  {
    title: 'Operasyonel Servisler',
    url: ROUTE_PATHS.selfService,
    type: 'Sayfa',
    keywords: ['it destek', 'ticket', 'servis', 'ulaşım', 'yemekhane', 'sss', 'destek']
  },
  {
    title: 'Zimmet Yönetimi',
    url: ROUTE_PATHS.inventory,
    type: 'Sayfa',
    keywords: ['zimmet', 'envanter', 'malzeme', 'rapor']
  },
  {
    title: 'Etkinlik Takvimi',
    url: ROUTE_PATHS.events,
    type: 'Sayfa',
    keywords: ['etkinlik', 'takvim', 'organizasyon']
  },
  {
    title: 'Anketler',
    url: ROUTE_PATHS.surveys,
    type: 'Sayfa',
    keywords: ['anket', 'geri bildirim', 'memnuniyet']
  },
  {
    title: 'Öneri ve Talep Kutusu',
    url: ROUTE_PATHS.innovation,
    type: 'Sayfa',
    keywords: ['öneri', 'inovasyon', 'fikir', 'talep']
  },
  {
    title: 'Koloğlu Akademi',
    url: 'https://akademi.kologlu.com.tr',
    type: 'Dış Link',
    keywords: ['akademi', 'eğitim', 'kurs'],
    external: true
  }
];

export const DASHBOARD_QUICK_LINKS = [
  {
    label: 'Duyurular',
    path: ROUTE_PATHS.announcements,
    icon: 'bx bxs-megaphone'
  },
  {
    label: 'Doküman Merkezi',
    path: ROUTE_PATHS.documents,
    icon: 'bx bxs-file-doc'
  },
  {
    label: 'Personel Rehberi',
    path: ROUTE_PATHS.directory,
    icon: 'bx bxs-group'
  },
  {
    label: 'İK Merkezi',
    path: ROUTE_PATHS.hr,
    icon: 'bx bxs-user-detail'
  },
  {
    label: 'İdari İşler',
    path: ROUTE_PATHS.administrative,
    icon: 'bx bxs-briefcase'
  },
  {
    label: 'Operasyonel Servisler',
    path: ROUTE_PATHS.selfService,
    icon: 'bx bx-support'
  },
  {
    label: 'Zimmet Yönetimi',
    path: ROUTE_PATHS.inventory,
    icon: 'bx bxs-package'
  }
];
